import React from 'react'
import "./header.css"
import { NavLink } from "react-router-dom";
import mainLogo from "../../images/mainLogo.png"
import mobileMainLogo from "../../images/mobileMainLogo.png"

function Header() {

    const ageGate = localStorage.getItem("ageGate")

    return (
        <header className="header">
            <img src={mainLogo}
                className="mainLogo" />

            <img src={mobileMainLogo}
                className='mobileMainLogo' />


            <div className="tabList">
                <NavLink to="/unesi-kod" style={{ pointerEvents: ageGate === "true" ? "" : 'none' }}>УЧЕСТВУЈ</NavLink>
                <NavLink to="/mehanizam" style={{ pointerEvents: ageGate === "true" ? "" : 'none' }}>МЕХАНИЗАМ</NavLink>
                <NavLink to="/nagrade" style={{ pointerEvents: ageGate === "true" ? "" : 'none' }}>НАГРАДЕ</NavLink>
                <NavLink to="/pravila" style={{ pointerEvents: ageGate === "true" ? "" : 'none' }}>ПРАВИЛА</NavLink>
                <NavLink to="/pitanja-i-odgovori" style={{ pointerEvents: ageGate === "true" ? "" : 'none' }}>ПИТАЊА И ОДГОВОРИ</NavLink>
                <NavLink to="/dobitnici" style={{ pointerEvents: ageGate === "true" ? "" : 'none' }}>ДОБИТНИЦИ</NavLink>
            </div>
        </header>
    )
}

export default Header